module.exports = __webpack_public_path__ + "static/media/cookhouse-primary.917f4196.jpg";